import type { Util } from "./util";
import type { SearchHandler } from "./searchHandler";
import type { OTracking } from "./types/tracking";
import type { Tracking } from "./tracking";
import type { Features } from "./features";

import { Cache } from "./Cache";
import { templates } from "./templates";
import { util } from "./util";
import { searchSuggest } from "./searchSuggest";
import { searchHandler } from "./searchHandler";
import { tracking } from "./tracking";
import { searchForm } from "./SearchForm";
import { searchbar } from "./Searchbar";
import { suggestTracking } from "./suggestTracking";
import { GlobalUtils } from "@otto-ec/global-resources/types/head/global-utils";
import { initFeatureFlags } from "./features";

export interface Squirrel extends Features {
  searchbar: typeof searchbar;
  searchHandler: SearchHandler;
  searchSuggest: typeof searchSuggest;
  suggestTracking: typeof suggestTracking;
  templates: Cache<Promise<string>>;
  cache: { Cache: typeof Cache };
  util: Util;
  searchForm: typeof searchForm;
  tracking: Tracking;

  enableEmptyState: boolean;
}

declare global {
  interface Window {
    o_squirrel: Squirrel;
    o_tracking: OTracking;
    o_util: GlobalUtils;
    squirrelTrackingInitialized: boolean;
  }
}

window.o_squirrel ||= {} as never;
initFeatureFlags(window.o_squirrel);
window.o_squirrel.cache = { Cache };
window.o_squirrel.util = util;
window.o_squirrel.searchForm = searchForm;
window.o_squirrel.templates = templates;
window.o_squirrel.searchHandler = searchHandler;
window.o_squirrel.tracking = tracking;
window.o_squirrel.searchSuggest = searchSuggest;
window.o_squirrel.searchbar = searchbar;
window.o_squirrel.suggestTracking = suggestTracking;
